import { styled } from '@mui/system';
import { HorizontalLine as HorizontalLine$1 } from '../ClockRangeInput/HorizontalLine.js';

const Container = styled('div')({
    width: '100px',
    display: 'flex',
    flexDirection: 'row',
});
const HorizontalLine = styled(HorizontalLine$1)({
    marginLeft: '6px',
});

export { Container, HorizontalLine };
//# sourceMappingURL=styled.js.map
